import React, { useState } from 'react';
import { X } from 'lucide-react';

interface FirstNamePromptProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (firstName: string) => void;
}

const FirstNamePrompt: React.FC<FirstNamePromptProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [firstName, setFirstName] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (firstName.trim()) {
      onSubmit(firstName.trim());
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="h-6 w-6" />
        </button>

        <h2 className="text-2xl font-semibold mb-2 text-gray-900">
          Hey there! 👋
        </h2>
        <p className="text-gray-600 mb-6">
          What should we call you? This helps make our conversations more personal.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Your first name"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            autoFocus
          />

          <button
            type="submit"
            disabled={!firstName.trim()}
            className="w-full py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 font-medium"
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default FirstNamePrompt;